import { InitializerExecutor } from '@wajeez-web/core/types';
import { FlowsActions } from '@wajeez-web/stores/content';
import { getFlowReader, setFlowReader } from '@wajeez-web/stores/content';
import { Content } from '@wajeez/wajeez.microservices';

export const initializeFlowReader: InitializerExecutor = async (dispatch) => {
  const flowReader = getFlowReader();

  if (!flowReader || flowReader[0]?.code || flowReader[0]?.message) {
    const res = await dispatch(FlowsActions.getFRlowReaderAsync());

    res.payload && setFlowReader(res.payload as Content.FlowOutput);
  } else {
    dispatch(FlowsActions.setFlowReader(flowReader));
  }
};
